import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap/lib';

import SvgIcon from 'components/SvgIcon/SvgIcon';
import Panel from 'components/Panel/Panel';

const RoleEligibilityBlock = ({ jobRole, portfolioLink }) => (
  <Panel
    className="box-shadow"
    style={{
      padding: '30px 20px',
    }}
  >
    <p className="text-center">
      <SvgIcon icon="clock" color="#0777DA" size="48" />
    </p>
    <p
      style={{
        textAlign: 'center',
        fontFamily: 'Lato',
        fontWeight: '700',
        fontSize: '20px',
      }}
    >
      <strong>Your roles don&apos;t match this job</strong>
    </p>
    <p
      style={{
        textAlign: 'center',
        fontFamily: 'Lato',
        fontSize: '16px',
      }}
    >
      This job is looking for a <strong>{jobRole}</strong>. To apply, add a
      matching or related featured role to your profile — this also affects your
      visibility to clients.{' '}
      <br />
      <br />
      Need help? Access our{' '}
      <a
        href="https://help.twine.net/en/article/why-cant-i-pitch-13aguem/"
        title="Help Center"
      >
        Help Center
      </a>
    </p>
    <p
      style={{
        textAlign: 'center',
        fontFamily: 'Lato',
        fontSize: '16px',
      }}
    >
      Once you&apos;ve updated your roles, refresh this page to apply.
    </p>
    <p
      style={{
        textAlign: 'center',
        fontFamily: 'Lato',
        fontSize: '16px',
      }}
    >
      <Link to={portfolioLink}>
        <Button bsStyle="primary">Update your featured roles</Button>
      </Link>
    </p>
  </Panel>
);

RoleEligibilityBlock.propTypes = {
  jobRole: PropTypes.string.isRequired,
  portfolioLink: PropTypes.string.isRequired,
};

export default RoleEligibilityBlock;
